import * as React from "react"
import { useEffect } from "react";
import { Box } from "@mui/material"

import {CommonFilters} from "@components";
import { useAppDefaultFilters } from "@hooks";
import {isLoadingCommonFilters, isSystemBusy} from "@signals";
import {COMMON_FILTER_KEYS, SHARE_OF_SEARCH_ROUTES} from "@constants";
import {isEmpty, elementsInLoading} from "./@signals";
import {batch} from "@preact/signals-react";


export default function KeywordFilters({ section=false }) {

	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(SHARE_OF_SEARCH_ROUTES.DETAILS_ID, SHARE_OF_SEARCH_ROUTES.ACCESS_KEY)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	useEffect(() => {
		if (elementsInLoading.value.length < 1) batch(() => {
			isLoadingCommonFilters.value = false
		})
	}, [elementsInLoading.value.length])

	return <Box data-tour="sos-details-filters">
	<CommonFilters
		components={{
			country: true, site: true,
			category: true, brand: true,
			sku: true,
			section, favFilters: true,
			favFiltersOnlyLine: true, keyword: true
		}}
		compProps={{
			category: { grid: { xs: 12, md: 5 } },
			site: { grid: { xs: 12, md: 4 } },
			keyword: { grid: { xs: 12, md: 5 } },
			sku: { grid: { md: 4 } },
			favFilters: {
				grid: { md: 3 },
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.KEYWORD, COMMON_FILTER_KEYS.SPLIT_KPI
				],
				dashboardKey: SHARE_OF_SEARCH_ROUTES.DETAILS_ID
			},
		}}
		onSubmit={() => batch(() => {
			isEmpty.value = false
			isSystemBusy.value = false
			isLoadingCommonFilters.value = true
		})}
		defaultValues={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
	</Box>
}